<template>
  <div class="journalism-details">
    <keep-alive><AppHeader :default-index="2"></AppHeader></keep-alive>
    <Banner :list="journaDetailsBanner"></Banner>
    <div class="breadcrumb container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/journalist' }"
          >新闻通告
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ noticeObj.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line container"></div>
    <div class="journalism-details-con container">
      <div class="journalism-details-con-title">
        {{ noticeObj.title }}
      </div>
      <div class="date">
        <i class="el-icon-discover"></i>
        {{ noticeObj.noticeTime }}
      </div>
      <div class="con" v-if="noticeObj.content">
        <el-image
          :src="`${imageUrl + noticeObj.titleImage}`"
          fit="cover"
        ></el-image>
<!--        <div class="valContent" v-html="noticeObj.content">{{ noticeObj.content | contentVal }}</div>-->
        <div class="valContent" v-html="noticeObj.content"></div>
      </div>
      <div class="con" v-if="noticeObj.content"></div>
      <div class="line"></div>
      <div class="butt">没有更多了</div>
    </div>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import { AppHeader, AppFooter } from 'content/App/app'
import Banner from '@/components/content/Banner'
import { noticeDetail, bannerDetail } from '@/services/api.js'
import config from '@/utils/config'

export default {
  name: 'journalismDetails',
  components: {
    AppHeader,
    Banner,
    AppFooter,
  },
  data() {
    return {
      imageUrl: '',
      noticeObj: { },
      journaDetailsBanner: [],
      content: `<section data-role="outer" style="box-sizing: border-box;"><section data-role="paragraph" style="box-sizing: border-box;"><section data-tools="135编辑器" data-id="97236" style="box-sizing: border-box;"><section style="margin: 10px auto;text-align: left;box-sizing: border-box;"><section hm_fix="273:400" style="display: flex;justify-content: flex-start;align-items: flex-end;box-sizing: border-box;"><section style="box-sizing: border-box;margin-bottom: -2px;width: 120px;"><section style="box-sizing: border-box;width: 120px;"><img data-src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3cJYkjgOqweMf8PBz2Ak0qQeheJib0ULGVqeaibubjNibRrx5kbbHzO6MzssQsMQXdMK1HjnCpeLZ2A/640?wx_fmt=png" data-type="png" data-width="100%" style="box-sizing: border-box; display: block; width: 100% !important; height: auto !important; visibility: visible !important;" data-ratio="0.30201342281879195" data-w="149" _width="100%" src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3cJYkjgOqweMf8PBz2Ak0qQeheJib0ULGVqeaibubjNibRrx5kbbHzO6MzssQsMQXdMK1HjnCpeLZ2A/640?wx_fmt=png&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1&amp;wx_co=1" crossorigin="anonymous" alt="图片" class="" data-fail="0"></section></section><section data-brushtype="text" style="margin-left: -60px;flex: 1 1 0%;letter-spacing: 1.5px;font-size: 14px;color: rgb(102, 166, 150);box-sizing: border-box;">点击上方“蓝字”关注我们</section></section></section></section></section><section data-role="paragraph"><section style="margin: 10px auto;text-align: center;"><section style="box-sizing:border-box;width: 100%;" data-width="100%"><img data-ratio="0.6540447504302926" data-src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99zwlArSAxLjQ9Mnn5j2GQiaiaA4fyhibrM8C4ghBmoiam6hROIawwc5bucA/640?wx_fmt=png" data-type="png" data-w="581" data-width="100%" height="207" style="box-sizing: border-box; display: block; width: 567px !important; height: auto !important; visibility: visible !important;" title="卡1.png" width="454" _width="567px" class="" src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99zwlArSAxLjQ9Mnn5j2GQiaiaA4fyhibrM8C4ghBmoiam6hROIawwc5bucA/640?wx_fmt=png&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1&amp;wx_co=1" crossorigin="anonymous" alt="图片" data-fail="0"></section><section style="display: flex;justify-content: flex-start;align-items: flex-end;margin-top: -10px;flex-direction: row-reverse;"><section style="box-sizing:border-box;width: 32px;"><img data-ratio="0.9774436090225563" data-src="https://mmbiz.qpic.cn/mmbiz_gif/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99icA7ibX6GtrsbsqCj4uPBXpawy03ibQ9yJ3sPyCEqH2PUMeNnhV7Lgia0Q/640?wx_fmt=gif" data-type="gif" data-w="266" data-width="100%" style="box-sizing: border-box; display: block; width: 100% !important; height: auto !important; visibility: visible !important;" _width="100%" src="https://mmbiz.qpic.cn/mmbiz_gif/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99icA7ibX6GtrsbsqCj4uPBXpawy03ibQ9yJ3sPyCEqH2PUMeNnhV7Lgia0Q/640?wx_fmt=gif&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1" class=" __bg_gif" data-order="0" alt="图片" data-fail="0"></section></section></section></section><section data-role="paragraph"><p><span style="font-size: 21px;font-family: 仿宋;">&nbsp; &nbsp; <span style="font-size: 19px;">日前，中国工商银行太原分行正在积极开展“社保卡惠民服务季”活动。活动期间工商银行各网点通过LED大屏播放宣传视屏、张贴海报、悬挂横幅、摆放易拉宝、发放宣传折页、工作人员现场讲解等形式开展社保卡宣传。</span></span></p><p><br></p></section><section data-tools="135编辑器" data-id="101575"><section style="margin: 10px auto;text-align: center;"><section style="box-sizing:border-box;width: 100%;" data-width="100%"><img data-ratio="0.6540447504302926" data-src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99ibyFcDJKwWicYhv1oAVDSzny5fBBicgItrjHZFOxo1thiccI72GsUX3ibKQ/640?wx_fmt=png" data-type="png" data-w="581" data-width="100%" height="341" style="box-sizing: border-box; display: block; width: 561px !important; height: auto !important; visibility: visible !important;" title="卡2.png" width="454" _width="561px" class="" src="https://mmbiz.qpic.cn/mmbiz_png/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99ibyFcDJKwWicYhv1oAVDSzny5fBBicgItrjHZFOxo1thiccI72GsUX3ibKQ/640?wx_fmt=png&amp;tp=webp&amp;wxfrom=5&amp;wx_lazy=1&amp;wx_co=1" crossorigin="anonymous" alt="图片" data-fail="0"></section><section style="display: flex;justify-content: flex-start;align-items: flex-end;margin-top: -10px;"><section style="box-sizing:border-box;width: 32px;"><img data-ratio="0.9774436090225563" data-src="https://mmbiz.qpic.cn/mmbiz_gif/1MbiaAoC4sS3Dtg68BNbzh9TsmrCphJ99icA7ibX6GtrsbsqCj4uPBXpawy03ibQ9yJ3sPyCEqH2PUMeNnhV7Lgia0Q/640?wx_fmt=gif" data-type="gif" data-w="266" data-width="100%" style="box-sizing: border-box; display: block; width: 32px !important; height: 31.2782px !important;" _width="100%" src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==" class=" __bg_gif" data-order="1"></section></section></section></section><section data-role="paragraph" style="box-sizing: border-box;"><p style="text-indent:43px;"><span style="font-size: 19px;font-family: 仿宋;">2020年11月20日，全国电子社保卡突破3亿大关。全国超过1/5的群众已可通过电子社保卡获得贴心便捷的就业、社保线上服务，幸福感满满。截至2020年11月底，太原市已签发电子社保卡累计约120万张。全国电子社保卡服务渠道已开通400余个，群众通过自己常用的APP或小程序，即可方便获取线上服务。这些渠道包括国家政务服务平台、国务院客户端微信小程序、电子社保卡小程序、掌上12333，工、农、中、建、交、邮储、招商、平安等各大银行，支付宝、微信、云闪付等25个全国性渠道，以及300多个人社部门和其他政府部门渠道、100多个银行和社会渠道。</span></p><p style="text-indent:43px;"><span style="font-size: 19px;font-family: 仿宋;">目前，中国工商银行太原分行在太原市辖区内已有60余家“金融+社保”一站式服务网点，市民持有效身份证件10分钟就可以办理社保卡新申请、激活、挂失、补换等社保卡业务。下一步我们将继续优化社保卡制卡网点建设，方便群众就近制卡，提升群众对社保服务的满意度。</span></p><p><br></p></section></section>`,
    }
  },
  created() {
    this.imageUrl = config.imageUrl
    // 详情轮播
    bannerDetail({
      type:'2'
    }).then( res_ => {
      this.journaDetailsBanner = res_.data
    })
    // 详情
    noticeDetail({
      id:this.$route.query.id
    }).then( res_ => {
      this.noticeObj = res_.data
    })
  },
  filters: {
    contentVal(val) {
      if (val == null) {
        return false
      } else {
        let regx = /<[^>]*>|<\/[^>]*>/gm
        let valRegx1 = val.replace(regx, '')
        let valRegx2 = valRegx1.replace(/&rdquo/g, '')
        let valRegx3 = valRegx2.replace(/&ldquo/g, '')
        let valRegx4 = valRegx3.replace(/&mdash/g, '')
        return valRegx4
      }
    },
  },
}
</script>

<style scoped lang="scss">
.breadcrumb {
  padding: 20px 0;
  font-size: $mo-font-size-base;
  ::v-deep.el-breadcrumb__inner {
    color: $mo-main-color;
    font-weight: 600;
  }
  ::v-deep.is-link {
    color: $mo-text-color-grey;
    font-weight: 500;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #bfc6cc;
}
.journalism-details-con {
  .con {
    margin: 20px 0;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 37px;
    .valContent {
      text-indent: 1cm;
    }
  }
  .journalism-details-con-title {
    font-size: $mo-font-size-xl;
    font-weight: 600;
    line-height: 60px;
  }
}
.butt {
  color: $mo-text-color-placeholder;
  text-align: center;
  line-height: 70px;
}
</style>
